<template>
    <div class="quickpay-esign-overview">
        <QuickpayPaymentHeader
            :companyName="data.corporation.name"
            :amount="data.document.amount_due"
            :currency="data.document.currency"
            :logoUrl="data.corporation.logoUrl"
            :hideAmount="data.document.hide_amount_due"
        />
        <QuickpayDownloadDocument
            :docType="data.document.doctype"
            :docId="data.document.id"
            :corpId="data.document.corpid"
            :pdfUrl="data.document.pdf_link"
            :documentNumber="data.document.number"
            :documentStep="data.document.step"
            :expired="data.document.expired"
            class="quickpay-esign-overview__download-document"
        />
        <QuickpayCGV
            v-if="data.condition"
            :condition="data.condition"
            :checked="cgvAccepted"
            :hasError="cgvError"
            @update:checked="handleCgvChange"
        />
        <QuickpayEsignCard :providerEsign="data.esign_link.provider" @sign="handleSignClick" />
        <QuickpayDeadlines
            v-if="hasDeadlines"
            :deadlines="data.deadlines"
            :currency="data.document.currency"
        />

    </div>
</template>

<script>
import QuickpayPaymentHeader from 'vcomponents/quickpay/QuickpayPaymentHeader.vue';
import QuickpayEsignCard from 'vcomponents/quickpay/esign/QuickpayEsignCard.vue';
import QuickpayCGV from 'vcomponents/quickpay/QuickpayCGV.vue';
import QuickpayDownloadDocument from 'vcomponents/quickpay/QuickpayDownloadDocument.vue';
import QuickpayDeadlines from 'vcomponents/quickpay/QuickpayDeadlines.vue';

import { saveConditionAcceptation } from 'api/quickpay/quickpayService.js';

export default {
    components: {
        QuickpayPaymentHeader,
        QuickpayEsignCard,
        QuickpayCGV,
        QuickpayDownloadDocument,
        QuickpayDeadlines,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
        hash: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            cgvAccepted: false,
            cgvError: false,
        };
    },
    computed: {
        hasCgv() {
            return !!this.data.condition;
        },
        hasDeadlines() {
            return this.data.deadlines?.length > 0;
        },
    },
    methods: {
        handleCgvChange(value) {
            this.cgvAccepted = value;
            if (value) {
                this.cgvError = false;
            }
        },
        handleSignClick() {
            if (this.hasCgv && !this.cgvAccepted) {
                this.cgvError = true;
                return;
            }
            window.location.href = this.data.esign_link.link;
            saveConditionAcceptation({ hash: this.hash });
        },
    },
};
</script>

<style lang="scss" scoped>
.quickpay-esign-overview {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: var(--spacing-3);
    padding: var(--spacing-1);

    &__download-document {
        @media (min-width: 1024px) {
            display: none;
        }
    }
}
</style>
